import { Injectable, inject } from '@angular/core';
import { Subject, Observable, firstValueFrom } from 'rxjs';
import { ConfirmOptions, ConfirmState } from '../types/confirm-types';
import { MrTranslatePipe } from '../pipes/mr-translate.pipe';

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private mrTranslate = inject(MrTranslatePipe);

  private state$ = new Subject<ConfirmState>();
  confirmState$ = this.state$.asObservable();

  /* ============================
     Observable API
     ============================ */
  confirm(options: ConfirmOptions): Observable<boolean> {
    const result$ = new Subject<boolean>();

    this.state$.next({
      options: {
        type: 'info',
        okText: this.mrTranslate.transform('OK'),
        cancelText: this.mrTranslate.transform('Abbrechen'),
        showCancel: true,
        ...options,
      },
      result$,
    });

    return result$.asObservable();
  }

  async confirmAsync(options: ConfirmOptions): Promise<boolean> {
    return firstValueFrom(this.confirm(options));
  }

  /* ============================
     Shortcut Helper
     ============================ */
  info(
    message: string,
    showCancelButton = true,
    textOK = 'OK',
    textCancel = 'Abbrechen',
    title = 'MR.pro®'
  ): Promise<boolean> {
    return this.confirmAsync({
      title,
      message,
      type: 'info',
      okText: this.mrTranslate.transform(textOK),
      cancelText: this.mrTranslate.transform(textCancel),
      showCancel: showCancelButton,
    });
  }

  warning(
    message: string,
    showCancelButton = true,
    textOK = 'OK',
    textCancel = 'Abbrechen',
    title = 'MR.pro®'
  ): Promise<boolean> {
    return this.confirmAsync({
      title,
      message,
      type: 'warning',
      okText: this.mrTranslate.transform(textOK),
      cancelText: this.mrTranslate.transform(textCancel),
      showCancel: showCancelButton,
    });
  }

  danger(
    message: string,
    showCancelButton = true,
    textOK = 'OK',
    textCancel = 'Abbrechen',
    title = 'MR.pro®'
  ): Promise<boolean> {
    return this.confirmAsync({
      title,
      message,
      type: 'danger',
      okText: this.mrTranslate.transform(textOK),
      cancelText: this.mrTranslate.transform(textCancel),
      showCancel: showCancelButton,
    });
  }
}
